<template>
  <b-modal v-model="showModal">
    <div slot="modal-title">
      {{ $t('message.bank_transfer.confirm_bank_transfer_modal_title') }}
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <h4>{{ $t('message.bank_transfer.total_cost') }}</h4>
        <h2 class="text-info mb-0">{{ order.order_summary_total.total | currency }}</h2>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12">
        <h4>{{ $t('message.bank_transfer.detail') }}</h4>
        <div>
          <img :src="globalState.bankAccountData.image_url" width="160" class="mb-2">
        </div>
        <div>{{ $t('message.bank_transfer.account_name') }}: {{ globalState.bankAccountData | multiLangName }}</div>
        <div class="d-flex align-items-center justify-content-center">
          <div class="flex-grow-1">
            <div>{{ $t('message.bank_transfer.account') }}: {{ globalState.bankAccountData.account_number }}</div>
          </div>
          <div class="text-right">
            <button class="btn btn-outline-info"
                    @click="isCopied = true"
                    v-clipboard:copy="globalState.bankAccountData.account_number">
              {{ isCopied ? $t('message.button.copied') : $t('message.button.copy') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div v-if="!uploadSuccess">
          <vue-dropzone ref="vueDropzone"
                        id="dropzone"
                        class="dropzone-dashed"
                        :options="dropzoneOptions"
                        @vdropzone-max-files-exceeded="vueDropZoneMaxFilesExceeded"
                        @vdropzone-mounted="vueDropZoneMounted"
                        @vdropzone-success="vueDropZoneSuccess"/>
          <div class="text-remark py-2">
            {{ $t('message.bank_transfer.transfer_picture_remark01') }}
          </div>

          <button class="btn btn-info btn-block"
                  @click="performUpload()">
            {{ $t('message.button.submit') }}
          </button>
        </div>
        <div v-else>
          <i class="fas fa-check-circle -status-accepted"></i>
          {{ $t('message.bank_transfer.upload_success') }}
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <b-btn class="float-right" variant="secondary" @click="showModal = false">
        {{ $t('message.button.close') }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import VueCoreImageUpload from 'vue-core-image-upload'
  import vue2Dropzone from 'vue2-dropzone'

  export default {
    components: {
      VueCoreImageUpload,
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        showModal: false,
        transferAmount: 0,
        transferPicture: null,
        hours: null,
        minutes: null,
        uploadSuccess: false,
        isLoading: false,
        isCopied: false,
        dropzoneOptions: {
          acceptedFiles: 'image/*',
          url: 'https://beneat.co',
          thumbnailWidth: 160,
          thumbnailHeight: 160,
          maxFilesize: 5,
          dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.attach_slip_here')}`,
          addRemoveLinks: true,
          autoProcessQueue: false,
          maxFiles: 1
        }
      }
    },
    computed: {
      ...mapGetters({
        authState: 'auth/getState',
        globalState: 'globalVal/getState',
        order: 'orderDetail/getOrderDetail',
        user: 'auth/getUser'
      })
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      showConfirmBankTransferModal (status) {
        this.showModal = status
        // Open Modal
        if (status) {
          this.isCopied = false
          this.transferAmount = Math.round(this.order.order_summary_total.total * 100) / 100
        }
      },
      pad (num) {
        return (num < 10) ? '0' + num.toString() : num.toString()
      },
      generateTime () {
        this.hours = []
        for (let i = 0; i <= 23; i++) {
          this.hours[i] = this.pad(i)
        }
        this.minutes = []
        for (let i = 0; i <= 59; i++) {
          this.minutes[i] = this.pad(i)
        }
      },
      async finishConfirmBankTransfer () {
        this.isLoading = false
        this.showModal = false
        await this.loadOrderDetail(this.order.id)
      },
      performUpload () {
        this.isLoading = true
        this.$refs.vueDropzone.processQueue()
      },
      vueDropZoneMaxFilesExceeded (file) {
        this.$refs.vueDropzone.removeAllFiles()
        this.$refs.vueDropzone.addFile(file)
      },
      vueDropZoneMounted () {
        const uploadUrl = `${this.$http.options.root}/orders/${this.order.id}/save-bank-transfer-picture`
        this.$refs.vueDropzone.options.url = uploadUrl
        this.$refs.vueDropzone.setOption('url', uploadUrl)
        const headers = {'Authorization': `Bearer ${this.authState.token}`}
        this.$refs.vueDropzone.options.headers = headers
        this.$refs.vueDropzone.setOption('headers', headers)
      },
      vueDropZoneSuccess (file, response) {
        if (!response.error) {
          this.uploadSuccess = true
          this.transferPicture = response.image_url
          this.bankTransferId = response.bank_transfer_id
          this.finishConfirmBankTransfer()
        }
      }
    },
    mounted () {
      this.generateTime()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ConfirmBankTransferModal.vue